import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { OpsappService } from '../../services/opsapp.service';

@Component({
  selector: 'app-instruments',
  templateUrl: './instrument-categories.component.html',
  styleUrls: ['./instrument-categories.component.css']
})
export class InstrumentCategoriesComponent implements OnInit {
  categoryData: any;
  loading: boolean = true;

  constructor(private opsappService: OpsappService, 
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService){
  }

  ngOnInit(){
    this.populateCategories();
  }

  populateCategories(){
    this.loading = true;
    this.opsappService.getInstrumentCategories().then(data => {
      this.categoryData = data;
      console.log(this.categoryData);
      this.loading = false;
    });
  }

  openCategory(category: any){
    this.opsappService.activeInstrumentCategory.next(category);
    this.router.navigate(["instrument-list"], { relativeTo: this.route.parent })
  }
}